import React from 'react';
import {ThumbnailGrid} from '../../components';
import {useQuery} from '@apollo/react-hooks';
import {ALBUMS_QUERY} from './graphql/AlbumsQuery';
import {albumsQuery, albumsQueryVariables} from './graphql/types/albumsQuery';
import {useHistory} from 'react-router';

export default function Albums() {
  const {data} = useQuery<albumsQuery, albumsQueryVariables>(ALBUMS_QUERY);

  const history = useHistory();

  const items = data?.me?.library?.albums?.map(
    ({id, name, artistName, artwork}) => {
      return {
        id,
        name,
        artistName,
        image: artwork?.mediumUrl,
        resourceType: 'library-album' as const,
        onClick: () => {
          history.push(`/library/album/${id}`);
        },
      };
    },
  );

  const content = items ? (
    <ThumbnailGrid items={items} />
  ) : (
    <p>{'loading...'}</p>
  );

  return <div style={{marginBottom: '20px', marginTop: '20px'}}>{content}</div>;
}
